import { useLocation } from "react-router-dom";
import { SITE } from "../data/site";
import { trackEvent } from "../lib/track";

// "Book a Consultation" anchor that records a booking click for the current page.
export const BookingLink = ({ placement, testId, className = "", children }) => {
  const { pathname } = useLocation();
  return (
    <a
      href={SITE.booking}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      onClick={() => trackEvent("booking", pathname, placement)}
      className={className}
    >
      {children}
    </a>
  );
};
